module.exports = __webpack_public_path__ + "static/media/c2.87203e7e.m4a";